import { Check, RestartAlt } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { RegistrationFieldFilter } from '../../../../../../interfaces/interfaces';
import VyTooltip from '../../../../../common/VyTooltip';
import { useRegistrationFilter } from '../../../../../meeting/hooks/useRegistrationFilter';
import FilterField from './FilterField';

interface AttendeesFiltersInterface {
  messagingRegistrationFilters: RegistrationFieldFilter[];
  onApply: (filters: RegistrationFieldFilter[]) => void;
}

const AttendeesFilters = ({ messagingRegistrationFilters, onApply }: AttendeesFiltersInterface) => {
  const [filterFields, setFilterFields] = useState<RegistrationFieldFilter[]>(messagingRegistrationFilters);
  const methods = useForm();
  const { fields } = useRegistrationFilter();

  const { t } = useTranslation();

  const resetFilters = () => {
    const resetObj: { [x: string]: [] } = {};
    for (const obj of filterFields) {
      resetObj[obj.field] = [];
    }
    methods.reset(resetObj);
    onApply([]);
  };

  useEffect(() => {
    setFilterFields(messagingRegistrationFilters);
  }, [messagingRegistrationFilters]);

  return (
    <>
      {fields.length > 0 && (
        <div className="flex flex-col w-full justify-between items-center bg-gray-100 p-4">
          <FormProvider {...methods}>
            <form className="flex-grow w-full">
              <div className="w-full flex flex-col md:flex-row md:space-x-2">
                {fields.map((field) => (
                  <FilterField
                    field={field}
                    onChange={(values) => {
                      const _field = filterFields.find((ff) => ff.field === field._id);
                      if (!_field) setFilterFields([...filterFields, { field: field._id, values }]);
                      else {
                        if (values.length === 0 || (field.fieldType === 'checkbox' && values.length !== 1)) {
                          const _filterFields = [...filterFields];
                          _filterFields.splice(_filterFields.findIndex((ff) => ff.field === field._id));
                          setFilterFields(_filterFields);
                        } else {
                          const _filterFields = filterFields.map((ff) => (ff.field === field._id ? { ...ff, values } : ff));
                          setFilterFields(_filterFields);
                        }
                      }
                    }}
                    fieldValues={filterFields.find((ff) => ff.field === field._id)?.values}
                  />
                ))}
              </div>
            </form>
          </FormProvider>
          <div className="flex flex-row justify-center space-x-2">
            <VyTooltip title={t('event:messaging.apply-filters')}>
              <IconButton onClick={() => onApply(filterFields)}>
                <Check />
              </IconButton>
            </VyTooltip>
            <VyTooltip title={t('event:messaging.reset-filters')}>
              <IconButton onClick={resetFilters}>
                <RestartAlt />
              </IconButton>
            </VyTooltip>
          </div>
        </div>
      )}
      {fields.length === 0 && (
        <div className="w-full h-16 grid place-items-center">
          <p className="italic text-slate-500">{t('event:messaging.no-filters')}</p>
        </div>
      )}
    </>
  );
};
export default AttendeesFilters;
